"use client";

import { useEffect } from "react";

import { deliverOfferImpression, preloadOfferImpressionEmitter } from "./OfferImpression.delivery";
import { installOfferImpressionDelivery } from "./OfferImpression.delivery-bridge";

function install(): () => void {
  return installOfferImpressionDelivery(deliverOfferImpression, preloadOfferImpressionEmitter);
}

// Install during client module evaluation so an impression cannot race a
// provider effect during hydration. The root provider retains this authority
// for the lifetime of the document and refreshes it across HMR.
if (typeof window !== "undefined") install();

export default function OfferImpressionDeliveryProvider() {
  useEffect(install, []);
  return null;
}
